/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, QueryRenderer, graphql } from 'react-relay';

import { Redirect } from 'react-router';

import { Button } from './ui/button';

import QueryError from './QueryError';
import NavBar from './NavBar';
import Card from './Card';
import ProcessInvitationMutation from '../mutations/ProcessInvitationMutation';
import RelayEnv from '../RelayEnv';


class JoinChannel extends React.Component {
  constructor(props) {
    super(props);
    this.join = this.join.bind(this);
    this.state = { redirect: null };
  }

  join(e) {
    e.preventDefault();

    const onSuccess = (resp) => {
      let id = resp.processInvitation.channelEdge.node.id;
      let redirect = `/channels/${id}`;
      if (id === 'Channel_team') {
        redirect = '/';
      }

      return this.setState({
        redirect,
        loading: false,
      });
    };

    ProcessInvitationMutation.commit(null, this.props.token, onSuccess, () => {
      return this.setState({
        loading: false,
      });
    });

    return this.setState({
      loading: true,
    });
  }

  render() {
    const { invitation } = this.props;
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <div className="flex flex-col h-full w-full">
        <NavBar />
        <div className="flex flex-col items-center justify-center flex-grow bg-gray-50 p-4">
          <div className="max-w-md w-full">
            <Card>
              <form onSubmit={this.join} className="p-6">
                {invitation.teamName ? (
                  <>
                    <div className="mb-4">
                      <h2 className="text-2xl font-bold text-gray-900 mb-2">Join Team</h2>
                      <p className="text-gray-600">
                        You have been invited to join <strong>{invitation.teamName}</strong>. Joining
                        allows you to receive notifications from the owner.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mb-4">
                      <h2 className="text-2xl font-bold text-gray-900 mb-2">Join Channel</h2>
                      <p className="text-gray-600">
                        You have been invited to join <strong>{invitation.channel?.name}</strong>.
                        Joining allows you to receive notifications from the owner.
                        You can leave the channel at any time.
                      </p>
                    </div>
                  </>
                )}
                <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                  <Button
                    type="submit"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? 'Joining...' : 'Join'}
                  </Button>
                </div>
              </form>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

JoinChannel = createFragmentContainer(JoinChannel, {
  invitation: graphql`
    fragment JoinChannel_invitation on Invitation {
      id
      teamName
      channel {
        id
        name
      }
    }
  `,
});

class JoinChannelContainer extends React.Component {
  render() {
    let token;
    if (this.props.match) {
      ({ token } = this.props.match.params);
    }

    return (
      <QueryRenderer
        query={graphql`
          query JoinChannelQuery($token: String!) {
            invitation(token: $token) {
              ...JoinChannel_invitation
            }
          }
        `}
        variables={{ token }}
        environment={RelayEnv}
        render={({ error, retry, props }) => {
          if (error) {
            return <QueryError retry={retry} error={error} />;
          } else if (props) {
            return <JoinChannel {...this.props} {...props} token={token} />;
          } else {
            return null;
          }
        }}
      />
    );
  }
}

export default JoinChannelContainer;
